module.exports = __webpack_public_path__ + "img/264.clean_tables_chairs.906e3fbe.svg";